import { createUseStyles } from 'react-jss';
import BackgroundImage from '../../assets/images/404-background.png';

const styles = {
  page: {
    padding: '2.4rem 6.4rem',
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: 'cover',
    width: '100%',
    minHeight: '100vh',
  },
  pageContent: {
    padding: {
      left: '9.6rem',
      top: '17.8rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
